export default __webpack_public_path__ + "static/media/photo--sm--huda-7.2b81f599.jpg";